module.exports = __webpack_public_path__ + "media/img/avatars/projects/project-5-01cf68a06c9f4a5cb39d87f825e43cc6.jpg";